import React, { useEffect, useState } from 'react'
import Input from '../Input/Input'
import ResourceField from './ResourceField'
import Button from '../Button'

import "./styles.scss"
import { showToast, startLoading, stopLoading } from '../../services/common-service'
import BlipPortalToastTypes from '../../constants/blip-portal-toast-types'

import { IframeMessageProxy } from 'iframe-message-proxy'
import IMPContainer from '../../constants/iframe-message-proxy-container';

import { v4 as uuid } from 'uuid';
import Select from '../Input/Select'
import ResourceFields from '../ResourceFields'

export default function ModalResource({
    opened,
    setOpened,
    start,
    getResource
}) {
    const [isNew, setIsNew] = useState(true)
    const [data, setData] = useState({
        name: "",
        key: "",
        type: "collection",
        fields: [
            {
                label: "",
                name: "",
                type: ""
            }
        ]
    })

    useEffect(() => {
        if (opened) {
            if (Object.keys(opened).length == 0) {
                setData({
                    _id: uuid(),
                    name: "",
                    key: "",
                    type: "",
                    fields: [
                        {
                            label: "",
                            name: "",
                            type: ""
                        }
                    ]
                })
                setIsNew(true)
            } else {
                setData({ ...opened })
                setIsNew(false)
            }
        }
    }, [opened])

    const close = () => {
        setOpened(() => null)
    }

    const submit = async () => {
        try {
            startLoading()

            let resourcesManagerPlugin = []

            try {
                const result = await getResource("resourcesManagerPlugin", "resources")

                resourcesManagerPlugin = result.resources
            } catch (error) {
                throw error
            }

            let newResourcesManagerPlugin = resourcesManagerPlugin

            // console.log(newResourcesManagerPlugin)

            let resourcesManagerPluginIndex = newResourcesManagerPlugin.findIndex(resource => resource._id == data._id)

            if (resourcesManagerPluginIndex >= 0) {
                newResourcesManagerPlugin[resourcesManagerPluginIndex] = data
            } else {
                newResourcesManagerPlugin.push(data)
            }

            const result = await IframeMessageProxy.sendMessage({
                action: IMPContainer.Actions.SEND_COMMAND,
                content: {
                    command: {
                        method: IMPContainer.CommandMethods.SET,
                        uri: "/resources/resourcesManagerPlugin",
                        type: "application/json",
                        resource: { resources: newResourcesManagerPlugin }
                    },
                    // destination: IMPContainer.Destinations.BLIP_SERVICE
                }
            });

            start()
            close()
        } catch (error) {
            // console.log(JSON.parse(error))
            // console.error(error)
            showToast({
                type: BlipPortalToastTypes.DANGER,
                message: error?.message || "Ocorreu um erro"
            });
        } finally {
            stopLoading()
        }
    }

    const setValue = (key, value) => {
        setData(data => {
            data[key] = value
            return { ...data }
        })
    }

    const handleAddField = () => {
        setData(data => {
            data.fields.push({
                label: "",
                name: "",
                type: ""
            })

            return { ...data }
        })
    }

    return (
        <bds-modal open={opened != null} close-button="false" size="dynamic">
            <div className="modal-resources">
                {/* {JSON.stringify(data)} */}
                <div className="modal-body">
                    <bds-typo variant="fs-16" tag="h2" translate="" className="hydrated">Informações Básicas</bds-typo>
                    <div style={{ display: "flex", gap: 10 }}>
                        <div style={{ flex: 1 }}>
                            <Input
                                name="name"
                                label="Nome"
                                placeholder="Qual nome gostaria de dar para este recurso?"
                                value={data.name}
                                onChange={e => setValue("name", e.target.value?.trim())}
                                waitTime={50}
                                helperMessage="Nome utilizado apenas para visualização"
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <Input
                                name="key"
                                label="Chave"
                                placeholder="Chave do recurso"
                                value={data.key}
                                onChange={e => setValue("key", e.target.value?.trim())}
                                waitTime={50}
                                helperMessage="Utilizada para recuperar o valor do conteúdo pelo servidor"
                            />
                        </div>
                    </div>

                    <Select
                        label="Tipo do Recurso"
                        options={[
                            { text: "Coleção", value: "collection" },
                            { text: "Único", value: "single" },
                        ]}
                        value={data.type}
                        onChange={e => setValue("type", e.target.value?.trim())}
                        placeholder="Qual o tipo do recurso?"
                    />

                    <bds-typo variant="fs-16" tag="h2" translate="" className="hydrated">Campos</bds-typo>
                    <ResourceFields
                        data={data}
                        setData={setData}
                    />

                    <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                        <Button
                            variant={"primary"}
                            text="Novo campo"
                            onClick={handleAddField}
                            size="short"
                        />
                    </div>
                </div>
                {/* 
                <div style={{ maxWidth: 800 }}>
                    {JSON.stringify(data)}
                </div> */}

                <bds-modal-action>
                    <div className="flex justify-end" style={{ width: "100%" }}>
                        <bds-button variant="secondary" onClick={close}>Cancelar</bds-button>
                        <bds-button
                            onClick={submit}
                            disabled={!(
                                (data.name && data.name.trim().length > 0) &&
                                (data.key && data.key.trim().length > 0) &&
                                (data.type && data.type.trim().length > 0) &&
                                (data.fields && data.fields.length > 0)
                            )}
                        >Pronto</bds-button>
                    </div>
                </bds-modal-action>
            </div>
        </bds-modal>
    )
}